var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"myElement",staticClass:"relative bg- p-1 flex justify-center items-center",staticStyle:{"width":"50px","height":"50px"}},[_c('img',{ref:"test",staticClass:"flex-1 max-h-full",staticStyle:{"object-fit":"contain"},style:(_vm.finalProps),attrs:{"src":require(`./icons/${_vm.iconType}.png`)}}),(_vm.data)?_c('div',{staticClass:"flex flex-no-wrap",style:({
      position: `absolute`,
      width: 'fit-content',
      height: 'fit-content',
      left: '50%',
      top: '-0%',
      transform: `translate(-50%,-100%) `,
      borderRadius: '3px',
      overflow: 'hidden',
      boxShadow: '0 0 0 2px black',
    })},[_c('div',{staticClass:"justify-center items-center text-black flex flex-1",staticStyle:{"background":"#000"}},[_c('svg',{style:({
          transform: `rotate(${_vm.data.data.rotation}deg)`,
        }),attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"20","height":"20","viewBox":"0 0 24 24"}},[_c('path',{attrs:{"fill":_vm.data.data.color,"d":"M13 18v-8l3.5 3.5l1.42-1.42L12 6.16l-5.92 5.92L7.5 13.5L11 10v8h2M12 2a10 10 0 0 1 10 10a10 10 0 0 1-10 10A10 10 0 0 1 2 12A10 10 0 0 1 12 2Z"}})])]),_c('div',{style:({
        width: 'fit-content',
        height: 'fit-content',
        background: _vm.data.data.color,
        color: 'black',
        padding: '4px',
        whiteSpace: 'nowrap',
        fontSize: '10px',
      })},[_vm._v("\n      "+_vm._s(_vm.data.data.name)+"\n    ")])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }